// External libraries
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FETCH_TIMER } from '../../utils/constants';
// Typed dispatch and selectors

// Components

export const Notification = ({ status, time }: { time: number; status: string }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    let timer1 = setTimeout(() => {
      setShow(false);
    }, FETCH_TIMER);

    return () => {
      clearTimeout(timer1);
    };
  }, []);
  return (
    <>
      {show && (
        <>
          <div className={`notification-bar ${show ? 'hidden' : ''}`}>
            <Row style={{ justifyContent: 'center' }}>
              <Col className="col-12">
                <span
                  className="text-ellipsis"
                  style={{ fontSize: '0.8rem', whiteSpace: 'pre-wrap' }}
                >
                  {status}
                </span>
              </Col>
            </Row>
            {status === 'Fetching from blockchain' && (
              <Row className="notification-progress-container">
                <Col>
                  <div className="progress-bar" style={{ transform: 'translateY(0.5rem)' }}></div>
                </Col>
              </Row>
            )}
          </div>
          <p />
        </>
      )}
    </>
  );
};

export default Notification;
